import { Stack } from '@mui/joy';
import { ColDef, IRowNode } from 'ag-grid-community';

import { IExtractorVendorMapping } from 'companySettings/types';
import { DEFAULT_PLACEHOLDER } from 'core/constants';
import { TextLine } from 'core/elements';

interface IProps {
  colDef?: ColDef;
  data?: IExtractorVendorMapping;
  node?: IRowNode<IExtractorVendorMapping>;
}

export const VendorLocationCell = ({ colDef, data, node }: IProps) => {
  const vendor = data?.vendor;

  // Same per-CELL gate as VendorCell, keyed on this column's own id: under
  // `groupDisplayType: 'multipleColumns'` every ordinary column renders on every group row with no
  // data, and `node.key` there belongs to whichever column grouped the rows — only the auto group
  // column standing in for this one carries `showRowGroup`. The key is what `keyCreator` built, the
  // location name; the cell value on a group row would be one leaf's AP number.
  if (!data) {
    return 'vendorLocation' === colDef?.showRowGroup && node?.key ? (
      <TextLine text={node.key} textEllipsis />
    ) : null;
  }

  // The AP is the only identifier a location is guaranteed to carry, so it leads the cell when the
  // location name is missing (no ERP supplier-site link) rather than leaving the first line blank.
  const locationName = vendor?.vendorLocationName || vendor?.accountsPayableId;

  // Wrapped like the two-line path so the dash stays left-aligned — see VendorCell.
  if (!locationName) {
    return (
      <Stack>
        <TextLine text={DEFAULT_PLACEHOLDER} textEllipsis />
      </Stack>
    );
  }

  return (
    <Stack>
      <TextLine text={locationName} textEllipsis />

      {vendor.vendorLocationName && vendor.accountsPayableId && (
        <TextLine text={vendor.accountsPayableId} isSubText />
      )}
    </Stack>
  );
};
